// Professional Color Theme - Centralized Control
// Based on neutral grays with subtle accent colors

export const colors = {
  // Primary Brand Colors
  primary: {
    main: '#1272B3',       // Brand blue
    light: '#2C8FC7',      // Medium blue
    lighter: '#7CCAF0',    // Light blue
    bg: '#EAF6FD',         // Very light blue background
  },

  // Neutral Grays (Professional)
  gray: {
    50: '#f8fafc',
    100: '#f1f5f9',
    200: '#e2e8f0',
    300: '#cbd5e1',
    400: '#94a3b8',
    500: '#64748b',
    600: '#475569',
    700: '#334155',
    800: '#1e293b',
    900: '#0f172a',
  },

  // Status Colors (More subtle and professional)
  status: {
    open: {
      bg: '#f1f5f9',
      text: '#334155',
      border: '#cbd5e1',
    },
    inProgress: {
      bg: '#EAF6FD',
      text: '#2C63AE',
      border: '#7CCAF0',
    },
    testing: {
      bg: '#e0e7ff',
      text: '#3730a3',
      border: '#818cf8',
    },
    blocked: {
      bg: '#fee2e2',
      text: '#7f1d1d',
      border: '#fca5a5',
    },
    done: {
      bg: '#d1fae5',
      text: '#065f46',
      border: '#6ee7b7',
    },
    closed: {
      bg: '#f1f5f9',
      text: '#475569',
      border: '#cbd5e1',
    },
  },

  // Priority Colors (Subtle with better contrast)
  priority: {
    blocker: {
      bg: '#fee2e2',
      text: '#7f1d1d',
      border: '#fca5a5',
    },
    critical: {
      bg: '#fed7aa',
      text: '#7c2d12',
      border: '#fb923c',
    },
    high: {
      bg: '#fef3c7',
      text: '#78350f',
      border: '#fbbf24',
    },
    medium: {
      bg: '#EAF6FD',
      text: '#2C63AE',
      border: '#7CCAF0',
    },
    low: {
      bg: '#f1f5f9',
      text: '#475569',
      border: '#cbd5e1',
    },
  },

  // Semantic Colors
  success: {
    main: '#16a34a',
    light: '#22c55e',
    bg: '#f0fdf4',
  },
  warning: {
    main: '#ca8a04',
    light: '#eab308',
    bg: '#fefce8',
  },
  error: {
    main: '#dc2626',
    light: '#ef4444',
    bg: '#fef2f2',
  },
  info: {
    main: '#0284c7',
    light: '#0ea5e9',
    bg: '#f0f9ff',
  },

  // Background Colors
  background: {
    default: '#ffffff',
    paper: '#ffffff',
    subtle: '#f8fafc',
    hover: '#f1f5f9',
  },

  // Text Colors
  text: {
    primary: '#0f172a',
    secondary: '#475569',
    disabled: '#94a3b8',
    hint: '#cbd5e1',
  },

  // Border Colors
  border: {
    light: '#f1f5f9',
    main: '#e2e8f0',
    dark: '#cbd5e1',
  },
};

// Helper function to get status color
export const getStatusColor = (status) => {
  const statusMap = {
    'Open': colors.status.open,
    'In Progress': colors.status.inProgress,
    'Testing': colors.status.testing,
    'Blocked': colors.status.blocked,
    'Done': colors.status.done,
    'Closed': colors.status.closed,
    'Fixed': colors.status.done,
    'Not Reproducible': colors.status.closed,
    'Invalid': colors.status.closed,
    "Won't Fix": colors.status.closed,
    'Duplicate': colors.status.closed,
    'Reopened': colors.status.inProgress,
  };
  return statusMap[status] || colors.status.open;
};

// Helper function to get priority color
export const getPriorityColor = (priority) => {
  const priorityMap = {
    'Blocker': colors.priority.blocker,
    'Critical': colors.priority.critical,
    'High': colors.priority.high,
    'Medium': colors.priority.medium,
    'Low': colors.priority.low,
  };
  return priorityMap[priority] || colors.priority.medium;
};

export default colors;
